import { Spinner } from "../lib/ui";

/** Suspense fallback shown while a lazily-loaded route chunk downloads.
 * Deliberately minimal — a centered spinner on the app background — so it
 * reads as a momentary transition, not a full-page loading screen. Route
 * chunks are small and CDN-cached, so this is on screen for a blink on the
 * first visit to a route and never again. */
export function RouteFallback() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg)",
      }}
    >
      <Spinner size={24} color="var(--fg-muted, #888)" />
    </div>
  );
}
